import type { DeepString } from "@/lib/i18n";

/**
 * CAdvertisements - polskie tlumaczenia (Ogloszenia - drzewo kategorii + search).
 *
 * `adsCount(n)` - "1 ogloszenie", "2 ogloszenia", "5 ogloszen" (PL plural rules).
 * `formatPrice(p)` - "199,00 zl" (PL locale, currency suffix).
 * `resultsTitle(n)` - "Znaleziono 7 ogloszen" (per locale plural).
 */
export const pl = {
  emptyData: "Brak danych do wyświetlenia.",

  /* Search */
  searchTitle: "Wyszukiwarka",
  searchBtn: "Szukaj",
  allTypes: "Wszystkie typy",
  fields: {
    keyword: "Fraza",
    type: "Typ",
    priceFrom: "Cena od",
    priceTo: "Cena do",
  },

  /* Validation */
  validation: {
    invalidPrice: "Niepoprawna wartość ceny (max 2 miejsca po przecinku).",
  },

  /* Categories */
  categoriesTitle: "Kategorie",
  noCategories: "Brak kategorii.",
  adsCount: (n: number): string => {
    /* Polskie reguły: 1 - liczba pojedyncza, 2-4 (oprócz 12-14) - dualis,
       pozostałe - mnoga. */
    const abs = Math.abs(n);
    const mod10 = abs % 10;
    const mod100 = abs % 100;
    if (abs === 1) return "1 ogłoszenie";
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14))
      return `${n} ogłoszenia`;
    return `${n} ogłoszeń`;
  },

  /* Search results */
  resultsTitle: (n: number): string => {
    const abs = Math.abs(n);
    const mod10 = abs % 10;
    const mod100 = abs % 100;
    if (abs === 1) return "Znaleziono 1 ogłoszenie";
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14))
      return `Znaleziono ${n} ogłoszenia`;
    return `Znaleziono ${n} ogłoszeń`;
  },
  noAdsFound: "Nie znaleziono ogłoszeń pasujących do podanych kryteriów.",
  addDate: "Dodano",
  price: "Cena",
  negotiatedPrice: "Cena do uzgodnienia",
  priceNotSet: "-",
  /** `formatPrice(199.5)` -> "199,50 zł" (PL locale). */
  formatPrice: (value: number): string => {
    try {
      return new Intl.NumberFormat("pl-PL", {
        style: "currency",
        currency: "PLN",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    } catch {
      return `${value.toFixed(2)} zł`;
    }
  },
  readMore: "Czytaj więcej ->",
} as const;

export type CAdvertisementsTranslations = DeepString<typeof pl>;
